import component from './component';

export default component;



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js